import React from "react";
import Container from "@material-ui/core/Container";
import { MailOpened } from "iconoir-react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import Typography from "../components/Typography";
import Button from "../components/Button";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      backgroundColor: grey[200],
    },
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(6),
    },
    button: {
      marginTop: theme.spacing(3),
    },
    icon: {
      marginRight: theme.spacing(1.5),
    },
    subheading: {
      maxWidth: 560,
      marginTop: theme.spacing(2),
    },
    responseTime: {
      marginTop: theme.spacing(3),
    },
  });

function SupportHero(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Typography variant="h2" marked="center" align="center">
          Support
        </Typography>
        <Typography variant="h5" align="center" className={classes.subheading}>
          Need help connecting your Slack workspace or using Dubslack? We're
          happy to help.
        </Typography>
        <Button
          color="secondary"
          variant="contained"
          size="large"
          className={classes.button}
          href={"mailto:support@dubslack.com"}
        >
          <MailOpened
            color={"currentColor"}
            width={"1.5em"}
            height={"1.5em"}
            className={classes.icon}
          />
          support@dubslack.com
        </Button>
        <Typography variant="body1" className={classes.responseTime}>
          Expected response time: within one business day.
        </Typography>
      </Container>
    </section>
  );
}

export default withStyles(styles)(SupportHero);
